module.exports = __webpack_public_path__ + "static/media/wicket7.8aa3883d.png";